import React from "react";
import classNames from "classnames";

const QuantitySelector = ({ count, toggleCountQuantity, handleChangeCount }) => {
  return (
    <div className="quantity-selector mt-2">
      <div role="group" className="quantity-selector__wrapper">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className={classNames(
            "quantity-selector__button",
            count < 2 && "quantity-selector__button--disabled"
          )}
          type="button"
          disabled={count < 2}
          onClick={toggleCountQuantity}
        ></button>
        <div className="quantity-selector__textfield">
          <input
            aria-invalid="false"
            type="text"
            id="quantity-selector"
            className="quantity-selector__textfield-input"
            readOnly="readonly"
            value={count}
            onChange={handleChangeCount}
          ></input>
        </div>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className="quantity-selector__button quantity-selector__button--right"
          type="button"
          onClick={() => toggleCountQuantity("increment")}
        ></button>
      </div>
    </div>
  );
};

export default QuantitySelector;
